import React from 'react'
import { COLORS } from '../../../config';

function UploadIcon({
  className,
  stroke
}) {
  return (
    <div className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke={stroke? stroke : COLORS.colorPrimary}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
      </svg>
    </div>
  )
}

export default UploadIcon;
  